/* eslint-disable no-undef */
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-cycle
import { DesktopNavigation, MobileNavigation } from './NavBar';
import {
  isTrialSection,
} from '../../utils/pageURLCheck';

const calculateScrollDistance = () => {
  const scrollTop = window.scrollY + 63; // how much the user has scrolled by
  const scrollPosition = scrollTop;

  return scrollPosition;
};

const getDocHeight = () => Math.max(
  document.body.scrollHeight,
  document.documentElement.scrollHeight,
  document.body.offsetHeight,
  document.documentElement.offsetHeight,
  document.body.clientHeight,
  document.documentElement.clientHeight
);
const calculateScrollPercentage = () => {
  const scrollTop = window.scrollY + 63; // how much the user has scrolled by
  const winHeight = window.innerHeight;
  const docHeight = getDocHeight();

  const totalDocScrollLength = docHeight - winHeight;
  const scrollPosition = Math.floor((scrollTop / totalDocScrollLength) * 100);

  return scrollPosition;
};

function Header(props) {
  const {
    pathname,
    menu,
    useDarkBackground,
    useDarkBackgroundWithScroll,
    showScrollProgressBar,
    title,
  } = props;

  const [scrollPosition, setScrollPostion] = useState(false);
  const [scrollPercentage, setScrollPercentage] = useState(false);

  useEffect(() => {
    function onScroll() {
      requestAnimationFrame(() => {
        if (useDarkBackgroundWithScroll || Boolean(title)) {
          setScrollPostion(calculateScrollDistance());
        }
        if (showScrollProgressBar) {
          setScrollPercentage(calculateScrollPercentage());
        }
      });
    }

    if (Boolean(title) || useDarkBackgroundWithScroll || showScrollProgressBar) {
      window.addEventListener('scroll', onScroll);
    }
    
    return function cleanUp() {
      window.removeEventListener('scroll', onScroll);
    };
  }, [scrollPosition]);

  const navigationProps = {
    pathname,
    menu,
    showScrollProgressBar,
    // Shows the title and hide the header when the scroll position is more than 400:
    title: (scrollPosition + 1) > 400 ? title : '',
  };

  if (useDarkBackground || useDarkBackgroundWithScroll) {
    navigationProps.useDarkBackground = (useDarkBackground || (scrollPosition + 1) < 400);
  }
  if (showScrollProgressBar) {
    navigationProps.scrollPercentage = scrollPercentage;
  }
  const hideMenuButton = isTrialSection(pathname);

  return (
    <Fragment>
      <DesktopNavigation
        {...navigationProps}
      />
      <MobileNavigation
        {...navigationProps}
        hideMenuButton={hideMenuButton}
      />
    </Fragment>
  );
}

Header.defaultProps = {
  menu: null,
  useDarkBackground: false,
  useDarkBackgroundWithScroll: false,
  showScrollProgressBar: false,
  title: '',
};
Header.propTypes = {
  pathname: PropTypes.string.isRequired,
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  useDarkBackground: PropTypes.bool,
  useDarkBackgroundWithScroll: PropTypes.bool,
  showScrollProgressBar: PropTypes.bool,
  title: PropTypes.string,
};

export default Header;
